import styled from 'styled-components';

const InactiveLabel = styled.span`
  user-select: none;
  color: #999999;
`;

export { InactiveLabel };
